import { Container, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function Dashboard() {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <Container 
          style={{ height: "80vh" }}
    className="d-flex justify-content-center align-items-center">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <Card className="p-4 shadow-lg border-0 text-center" style={{ width: 420 }}>
          <h2 className="text-gradient mb-3">Dashboard</h2>
          <p className="text-muted">
            You are signed in 🎉
          </p>
          <Button variant="danger" onClick={logout} className="fw-bold">
            Logout
          </Button>
        </Card>
      </motion.div>
    </Container>
  );
}